var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[[_c('v-container',{directives:[{name:"role",rawName:"v-role",value:('func'),expression:"'func'"}],staticClass:"grey lighten-5"},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',[_c('div',{staticClass:"container"},[(_vm.loaded)?_c('LineChart',{attrs:{"chartdata":_vm.chartdata,"options":_vm.options}}):_vm._e()],1)])],1)],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }